/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The secret access type denotes how a secret is made available within a container. Available Options are "env".
 */
export enum SecretAccessType {
	ENV = "env",
}
